import React, { useRef } from "react";
import { save } from "../../../features/auth/authSlice";
import toast from "react-hot-toast";
import { Form, Input, Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";

const { TextArea } = Input;
function Reports() {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { saving } = useSelector((state) => state.save);

  const onFinish = async (data) => {
    const res = await dispatch(
      save({
        ...data,
        url: "prod/member",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await form.resetFields();
    } else {
      toast.error(res?.payload?.message);
    }
  };
  return (
    <div className="mt-[14rem] w-full flex flex-col items-center justify-center" id="reports">
      <div className="bg-[#F1F3F5] py-[.875rem] px-[1.375rem] gap-[1.75rem] flex flex-col lg:w-[50rem] w-full">
        <span className="text-darkBlue text-[1rem] font-sora font-[600] ">
          Report Request Form
        </span>
        <span className="font-sora text-[#1A1A1A] text-[.75rem] font-[400]">
          Please complete this form to request a report.
        </span>
      </div>

      <div className="mt-[2.5rem] lg:w-[50rem] w-full">
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=""
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <Form.Item
            name="usrMemberType"
            className=""
            label={"Type"}
            rules={[
              {
                required: true,
                message: "Please select type",
              },
            ]}
          >
            <Select
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              //   options={
              //     memberTypes?.length > 0 &&
              //     memberTypes?.map((item) => ({
              //       value: item?.mbType,
              //       label: item?.mbType,
              //     }))
              //   }
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
            />
          </Form.Item>
          <Form.Item
            name="fullNames"
            label={"Name"}
            rules={[
              {
                required: true,
                message: "Please add name",
              },
            ]}
          >
            <Input className="input" />
          </Form.Item>
          <Form.Item
            name="fullNames"
            label={"Designation"}
            rules={[
              {
                required: true,
                message: "Please add designation",
              },
            ]}
          >
            <Input className="input" />
          </Form.Item>
          <Form.Item
            name="phoneNumber"
            label={"Active Phone Number"}
            rules={[
              {
                required: true,
                message: "Please add primary phone no",
              },
            ]}
          >
            <PhoneInput
              country="ke"
              onlyCountries={["ke"]}
              countryCodeEditable={false}
              className="input rounded-[6px] border !border-[#cacaca] !h-[42px]"
            />
          </Form.Item>

          <Form.Item
            name="prodComments"
            label={"Reason"}
            rules={[
              {
                required: true,
                message: "Please add reason",
              },
            ]}
          >
            <TextArea placeholder="Reason..." rows={5} className="text_area" />
          </Form.Item>

          <div className="flex justify-between mt-[48px] ">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center mb-[58px] gap-x-5">
              <div className="w-[150px]">
                <button
                  disabled={saving}
                  key="submit"
                  type="submit"
                  className="cstm-btn-2"
                >
                  {saving ? <Spin /> : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
}

export default Reports;
